<script>
    import { mapActions, mapState } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import TypographyWrapper from "@/components/TypographyWrapper";

    export default {
        name: "DocumentPersonal",
        components: { TypographyWrapper },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage["document-personal"],
            }),
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "document-personal" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.getStaticPage({ slug: "document-personal" });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
        },
        metaInfo() {
            return metaInfo.getMeta("document-personal");
        },
    };
</script>

<template>
    <div class="document-personal">
        <div class="l-container">
            <typography-wrapper>
                <h2>
                    Согласие на&nbsp;обработку персональных данных клиентов&nbsp;&mdash;
                    физических лиц
                </h2>
                <div class="document-personal__content" v-html="page.contentRight"></div>
            </typography-wrapper>
        </div>
    </div>
</template>

<style lang="scss">
    .document-personal {
        padding-bottom: 56px;

        h2 {
            max-width: 900px;
            text-align: center;
            margin-left: auto;
            margin-right: auto;
        }
    }

    .document-personal__content {
        padding: 16px;
        background-color: var(--service-background-color);
        border: var(--service-border);
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            padding: 26px 32px 12px;
        }
    }
</style>
